import { NgModule } from '@angular/core';
import { InsurerEditComponent } from './insurer-edit/insurer-edit.component';
import { InsurerListComponent } from './insurer-list/insurer-list.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    InsurerEditComponent,
    InsurerListComponent
  ],
})
export class InsurerModule { }
